
import type { PropOptions } from 'vue';
import Vue from 'vue';
import Dropdown from '@/components/common/Dropdown/Dropdown.vue';
import WarRoomSharePopup from '@/components/partials/war-room/WarRoomShare/WarRoomSharePopup/WarRoomSharePopup.vue';
import WarRoomShareButton from '@/components/partials/war-room/WarRoomShare/WarRoomShareButton/WarRoomShareButton.vue';
import { sharableTypes } from '@/components/partials/war-room/WarRoomShare/constants';
import { modalNames } from '~/components/partials/war-room/constants';
import DropdownToggler from '~/components/common/Dropdown/DropdownToggler.vue';
import warRoomSignUpMixin from '~/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

interface IData {
  isVisible: boolean;
}

export default Vue.extend({
  name: 'WarRoomShare',
  components: {
    Dropdown,
    WarRoomSharePopup,
    DropdownToggler,
    WarRoomShareButton,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    sharableType: {
      type: String,
      default: sharableTypes.POST,
      validvalidator: (val: string) => [sharableTypes.POST, sharableTypes.COMMENT].includes(val),
      required: true,
    } as PropOptions<string>,
    sharableUrl: {
      type: String,
      default: null,
      required: true,
    } as PropOptions<string>,
    sharableId: {
      type: Number,
      default: null,
      required: true,
    } as PropOptions<number>,
  },
  data(): IData {
    return {
      isVisible: false,
    };
  },
  computed: {
    buttonVariant(): string {
      return this.sharableType === sharableTypes.COMMENT ? 'borderless' : 'outline';
    },
  },
  methods: {
    togglePopup(isVisible: boolean): void {
      if (!this.isVisible) {
        this.sendClickShareButtonEvent();
      }

      this.isVisible = isVisible;
    },
    openShareModal() {
      this.sendClickShareButtonEvent();
      this.$modal.showWithRoute(
        { custom: modalNames.SHARE_POST_OR_COMMENT },
        { sharable_type: this.sharableType, sharable_url: this.sharableUrl },
      );
    },
    sendClickShareButtonEvent(): void {
      this.$analytics.logEvent('war-room__post__share-button__click', {
        objectType: this.sharableType,
        objectId: this.sharableId,
      });
    },
  },
});
